export function skipContent() {
	let skipBtn = $(".skip-content");
	skipBtn.focus(function () {
		skipBtn.addClass("show");
	}).focusout(function () {
		skipBtn.removeClass("show");
	});

	skipBtn.on("click", function () {
		$(this).removeClass("show");
		let target = $(this).attr("href");
		let scroll = $(target).offset().top;
		$("html, body").animate({scrollTop: scroll}, 1000);
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/skipContent.js